module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/plus icon-865067f2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/plus icon.svg
// module id = ./app/web/src/assets/plus icon.svg
// module chunks = 0